/**
 * Shared dashboard route paths.
 *
 * Both the admin-dashboard app (for its own router) and the
 * revvly-website (for cross-app links) import from here.
 * Changing a path here updates both apps automatically.
 */
export const DASHBOARD_ROUTES = {
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
} as const;
